import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import mascote from "../assets/mascote.png";
import cifrao from "../assets/cifrao.png";

export function Home() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [aceitouCookies, setAceitouCookies] = useState(() => {
    return localStorage.getItem("aceitouCookies") === "true";
  });

  const [cardsHome, setCardsHome] = useState([]);

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/home`);
        const data = await res.json();
        setCardsHome(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Erro ao buscar cards da home:", err);
        setCardsHome([]);
      }
    };

    fetchCards();
  }, []);

  const handleAceitarCookies = () => {
    localStorage.setItem("aceitouCookies", "true");
    setAceitouCookies(true);
  };

  return (
    <div className="bg-[#030E2C] text-white relative overflow-hidden">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#020C24] via-[#020C24] to-[#015FFF] py-8 px-4 sm:px-6 relative">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8 relative">
          <div className="relative flex justify-center md:justify-start flex-1">
            <img src={cifrao} alt="cifrão" className="absolute w-14 h-14 left-10 top-6 sm:w-20 sm:h-20" />
            <img src={mascote} alt="Mascote" className="w-[300px] sm:w-[400px] md:w-[500px] lg:w-[600px] object-contain z-10" />
          </div>

          <div className="text-center md:text-left max-w-xl">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
              Ganhe Dinheiro de Volta em Suas Primeiras Apostas!
            </h1>
            <p className="mb-6 text-gray-200 leading-relaxed">
              Receba <span className="font-bold text-white">cashback</span> em suas primeiras apostas e maximize seus ganhos agora!
            </p>

            <div className="relative inline-block">
              {user ? (
                <button
                  onClick={() => navigate("/offers")}
                  className="bg-blue-700 hover:bg-blue-600 text-white px-10 sm:px-16 py-3 rounded-full font-semibold shadow-lg transition relative z-10"
                >
                  Ver Ofertas
                </button>
              ) : (
                <button
                  onClick={() => navigate("/register")}
                  className="bg-blue-700 hover:bg-blue-600 text-white px-10 sm:px-16 py-3 rounded-full font-semibold shadow-lg transition relative z-10"
                >
                  Fazer cadastro
                </button>
              )}
              <img
                src={cifrao}
                alt="cifrão"
                className="absolute right-[-40px] sm:-right-32 top-1/2 transform -translate-y-1/2 w-12 h-12 sm:w-20 sm:h-20"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Cards da Home cadastrados pelo admin */}
      <div className="bg-gray-100 text-black py-12 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-center text-2xl font-bold mb-10">Nossas casas em destaque</h2>

          {/* Carrossel mobile - top 3 cards */}
          <div className="sm:hidden mb-8 overflow-hidden relative">
            <div className="flex gap-[6px] animate-slide">
              {cardsHome.slice(0, 3).map((card, index) => (
                <div
                  key={index}
                  onClick={() => {
                    const destino = `/cupom/${card.titulo.toLowerCase()}`;
                    if (!user) {
                      alert("Você precisa estar logado para acessar as ofertas.");
                      navigate("/login");
                    } else {
                      navigate(destino);
                    }
                  }}
                  className="min-w-[85%] flex-shrink-0 bg-white p-4 rounded-xl shadow hover:shadow-md transition cursor-pointer"
                >
                  <img
                    src={card.imagemUrl}
                    alt={card.titulo}
                    className="w-28 h-20 mx-auto mb-2 object-contain"
                  />
                  <p className="text-center font-normal">{card.titulo}</p>
                  <p className="text-center text-sm text-black font-semibold">{card.descricao}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Grid mobile com o restante dos cards */}
          {cardsHome.length > 3 && (
            <div className="grid sm:hidden grid-cols-2 gap-4 mb-8">
              {cardsHome.map((card, index) => (
                <div
                  key={index}
                  onClick={() => {
                    const destino = `/cupom/${card.titulo.toLowerCase()}`;
                    if (!user) {
                      alert("Você precisa estar logado para acessar as ofertas.");
                      navigate("/login");
                    } else {
                      navigate(destino);
                    }
                  }}
                  className="bg-white p-4 rounded-xl shadow hover:shadow-md transition cursor-pointer"
                >
                  <img
                    src={card.imagemUrl}
                    alt={card.titulo}
                    className="w-24 h-16 mx-auto mb-2 object-contain"
                  />
                  <p className="text-center text-sm font-normal">{card.titulo}</p>
                  <p className="text-center text-sm text-black font-semibold">{card.descricao}</p>
                </div>
              ))}
            </div>
          )}

          {/* Grid de cards para telas maiores */}
          <div className="hidden sm:grid grid-cols-2 md:grid-cols-4 gap-6">
            {cardsHome.map((card, index) => (
              <div
                key={index}
                onClick={() => {
                  const destino = `/cupom/${card.titulo.toLowerCase()}`;
                  if (!user) {
                    alert("Você precisa estar logado para acessar as ofertas.");
                    navigate("/login");
                  } else {
                    navigate(destino);
                  }
                }}
                className="bg-white p-4 rounded-xl shadow hover:shadow-md transition cursor-pointer"
              >
                <img
                  src={card.imagemUrl}
                  alt={card.titulo}
                  className="w-28 h-20 mx-auto mb-2 object-contain"
                />
                <p className="text-center font-normal">{card.titulo}</p>
                <p className="text-center text-sm text-black font-semibold">{card.descricao}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Pop-up de Cookies */}
      {!aceitouCookies && (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-300 p-4 text-sm text-gray-700 shadow-lg z-50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-center sm:text-left">
            Utilizamos cookies para melhorar sua experiência. Ao continuar navegando, você concorda com nossa{" "}
            <a href="/politica-de-privacidade" className="text-blue-700 underline">Política de Privacidade</a>.
          </p>
          <button
            onClick={handleAceitarCookies}
            className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 transition"
          >
            Aceitar
          </button>
        </div>
      )}
    </div>
  );
}
